<ng-content></ng-content>

@if (!print) {
    <div class="control">
        <button class="menu-button" (click)="prev.emit()" color="primary" mat-icon-button>
            <mat-icon fontSet="fa" fontIcon="fa-chevron-left" />
        </button>
    </div>
}

@if (fromDate && toDate) {
    <div class="indicator" [class.print]="print">
        <div class="week" [style.right.px]="isMobile ? null : weekright" [style.width.px]="isMobile ? null : weekwidth">
            <span>Week</span> {{ primaryWeekStart | date: 'w' }}
        </div>
    </div>
}

@if (singleDate) {
    <div class="indicator" [class.print]="print">
        <div class="week" [style.width.%]="isMobile ? null : 100">
            <span class="weeknumber">WK {{ singleDate | date: 'w' }} - </span>
            <span class="dow--long">{{ singleDate | date: 'EEEE' }}</span>
            <span class="dow--short">{{ singleDate | date: 'EEE' }}</span>
            <span class="date--long">{{ singleDate | date: 'd MMMM yyyy' }}</span>
            <span class="date--short">{{ singleDate | date: 'd MMM' }}</span>
        </div>
    </div>
}

@if (!print) {
    <div class="control">
        <button class="menu-button" [disabled]="disableNext" (click)="next.emit()" color="primary" mat-icon-button>
            <mat-icon fontSet="fa" fontIcon="fa-chevron-right" />
        </button>
    </div>
}
